export default {
  syncClients: (addon, data = null) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/sync-clients`, data),
  syncPlans: (addon, data = null) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/sync-plans`, data),
  proxyCall: (addon, endpoint, data = null) => $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/proxy/${endpoint}`, data),

  syncClient: (addon, client_uuid) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/sync-client/${client_uuid}/`),
  syncPlan: (addon, plan_uuid) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/sync-plan/${plan_uuid}/`),

  getSecclClient: (addon, account_uuid) => $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/client/${account_uuid}`),
  createSecclClient: (addon, data) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/client`, data),
  updateSecclClient: (addon, account_uuid, data) => $nuxt.$axios.patch($nuxt.$api.host + `/addons/seccl/${addon}/client/${account_uuid}`, data),
}
